var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AuthToken_1;
import { BeforeDeserialized, JSON, JsonSchema } from '@symon-ai/wisepipe-serialize';
export var AuthTokenType;
(function (AuthTokenType) {
    AuthTokenType["Bearer"] = "Bearer";
    AuthTokenType["BearerCustomJwt"] = "BearerCustomJwt";
    AuthTokenType["ApiKey"] = "APIKey";
    AuthTokenType["Internal"] = "Internal";
    AuthTokenType["TaskAuth"] = "TaskAuth";
})(AuthTokenType || (AuthTokenType = {}));
const schema = {
    $id: 'urn:wisepipe-user:AuthToken',
    type: 'object',
    properties: {
        token: { type: 'string' },
        tokenType: { type: 'string', enum: Object.values(AuthTokenType) }
    },
    required: ['token']
};
let AuthToken = AuthToken_1 = class AuthToken {
    setDefaults() {
        this.tokenType = AuthTokenType.Bearer;
    }
    constructor(token, type = AuthTokenType.Bearer) {
        this.token = token;
        this.tokenType = type;
        JSON.validate(this, AuthToken_1);
    }
    toString() {
        return this.token;
    }
    valueOf() {
        return this.token;
    }
    get type() {
        return this.tokenType;
    }
    get value() {
        return `${this.tokenType} ${this.token}`;
    }
    get tokenValue() {
        return this.token;
    }
    get header() {
        return AuthToken_1.Header;
    }
    static get Header() {
        return 'Authorization';
    }
    static get InternalHeader() {
        return 'wisepipe-authorization';
    }
};
__decorate([
    BeforeDeserialized()
], AuthToken.prototype, "setDefaults", null);
AuthToken = AuthToken_1 = __decorate([
    JsonSchema(schema)
], AuthToken);
export { AuthToken };
//# sourceMappingURL=authToken.js.map